import { useComprehensiveTopNav, useCustomToast } from 'hooks';
import { routes } from 'lib/api';
import { Button } from 'lib/components';
import { TextField } from 'lib/components/FormFields';
import { RateType } from 'lib/util';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { actions, RequestManager, useAppDispatch, useSelectRequest } from 'store';
import classes from './index.module.scss';

const AddServiceScreen = () => {
	const toast = useCustomToast();
	const { push, goBack } = useHistory();

	const dispatch = useAppDispatch();
	const { active } = useSelectRequest();

	const [name, setName] = useState('');
	const [description, setDescription] = useState('');

	useEffect(() => {
		const RM = new RequestManager(active);
		if (RM.idle()) return;

		if (RM.req(routes.SERVICE, 'POST')) {
			if (RM.failed()) {
				toast(active.message, 'error');
			} else if (RM.succeeded()) {
				toast(active.message);
				push('/settings/services');
			}
		}
	}, [active]);

	const handleCreate = () => {
		dispatch(
			actions.addService({
				name,
				description,
			})
		);
	};

	useComprehensiveTopNav('Add New Service', { notificationVisible: true });

	return (
		<div className={classes['service']}>
			<div className={classes['service-form']}>
				<div className={classes['service-info']}>
					<TextField
						placeholder="Does the patient have COVID-19?"
						label="Title"
						variant="labelled"
						value={name}
						onChange={(e) => setName(e.target.value)}
					/>
					<TextField
						label="Description"
						variant="labelled"
						value={description}
						onChange={(e) => setDescription(e.target.value)}
					/>
				</div>
			</div>
			<div className={classes['service-footerButtons']}>
				<Button title="Create New" variant="standard" color="primary" onClick={handleCreate} />
				<Button variant="standard" color="gray" title="Cancel" onClick={goBack} />
			</div>
		</div>
	);
};

export default AddServiceScreen;
